export type QueuedAction = {
	id: string;
	execute: () => Promise<void>;
	optimistic?: (() => (() => void) | null) | null;
	rollback?: (() => void) | null;
	toast?: {
		loading?: string;
		success?: string;
		error?: string | ((err: unknown) => string);
	};
	onSuccess?: () => void | Promise<void>;
	onError?: (err?: unknown) => void | Promise<void>;
};

export function createAction(action: Omit<QueuedAction, "id">): QueuedAction {
	return {
		...action,
		id: crypto.randomUUID(),
	};
}
